import React from 'react';
import { Card } from 'antd';

const DashboardItem = ({ children, title, statistics }) => (
  <Card
    title={title}
    statistics={statistics}
    style={{
      height: '100%',
      width: '100%',
    }}
  >
      {children}
  </Card>
);

export default DashboardItem;
